import Auth, { CognitoUser } from '@aws-amplify/auth'

export function logIn(username: string, password: string): Promise<CognitoUser | null> {
	return Auth.signIn(username, password)
}
